import React, { useState } from 'react'
import { FaUserMd } from 'react-icons/fa';
import MaintenanceCompaniesScreen from '../MaintainaceCompanies/MaintenanceCompanies';
import SuppliersScreen from '../Suppliers/Suppliers';
import { Card, Tabs } from 'antd';
import { BiBookOpen, BiBuildings, BiXCircle } from 'react-icons/bi';
import { BsClock } from 'react-icons/bs';
import BookingsScreen from '../BookingsScreen/BookingsScreen';
import SpecialistSessionsScreen from '../SpecialistBookingsScreen/SpecialistBookingsScreen';
import ClosedBySystem from '../ClosedBySystem/ClosedBySystem';

const BookingsAndSessions = () => {
    // const { isMobile, isTablet } = useResponsive();
    const [activeTab, setActiveTab] = useState('bookings');
const role =localStorage.getItem("role")
    
    const tabItems = [
        {
            key: 'bookings',
            label: (
                <span className="flex items-center gap-2">
                    <BiBookOpen />
                    Bookings
                </span>
            ),
            children: <BookingsScreen/>
        },
        {
            key: 'sessions',
            label: (
                <span className="flex items-center gap-2">
                    <BsClock />
                    Sessions
                </span>
            ),
            children: <SpecialistSessionsScreen  />
        },
        role==3&&{
            key: 'closed',
            label: (
                <span className="flex items-center gap-2 ">
                    <BiXCircle className=' text-lg' />
                    Closed By System
                </span>
            ),
            children: <ClosedBySystem/>
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 640px) {
                    .ant-card-body {
                        padding: 16px !important;
                    }
                }
            `}</style>

            <div className={``}>
                

                <Card style={{padding:0}} className="shadow-lg border-0 bg-white/90 backdrop-blur-sm mt-6">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                        className="medical-staff-tabs"
                    />
                </Card>
            </div>
        </div>
    );
};
export default BookingsAndSessions